import React from 'react'

import styled from '@emotion/styled'
import StyleVariales from '../styles/styles'
import {AlertTriangle} from 'react-feather'

// STYLE ##########################################################

const sv = StyleVariales

const Container = styled(`div`)`
  padding: 16px;
  border-radius: 4px;
  border: 1px solid ${sv.colors.error};

  ${sv.box};
  ${sv.flexRow};
  ${props => props.marginBottom ? 'margin-bottom: 10px;' : ''}
`

const ErrorText = styled(`div`)`
  margin-left: 8px;
  font-size: 12px;
  max-width: calc(100% - 40px);
  color: ${sv.colors.error};
`

// COMPONENT ##########################################################

const Error = ({error}) => {

  return (
    <Container marginBottom={props => props.marginBottom}>
      <AlertTriangle color={sv.colors.error} />
      <ErrorText dangerouslySetInnerHTML={{__html: error}} />
    </Container>
  )

}

export default Error
